import { ReactNode } from "react";

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  backgroundImage?: string;
  compact?: boolean;
  children?: ReactNode;
}

const PageHero = ({ eyebrow, title, subtitle, backgroundImage, compact = false, children }: PageHeroProps) => {
  return (
    <section
      className={`relative w-full overflow-hidden ${backgroundImage ? "" : "bg-secondary on-dark"} ${compact ? "pt-40 pb-24 md:pt-48 md:pb-28" : "pt-44 pb-28 md:pt-52 md:pb-36"}`}
    >
      {backgroundImage ? (
        <>
          <div className="absolute inset-0">
            <img
              src={backgroundImage}
              alt=""
              className="w-full h-full object-cover"
              loading="eager"
              decoding="async"
              width={1920}
              height={1080}
              {...({ fetchpriority: "high" } as any)}
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-rich-black/80 via-rich-black/50 to-rich-black/40" />
          <div className="relative z-10 mx-auto max-w-content px-5 md:px-12 text-center">
            {eyebrow && (
              <p className="font-body text-[10px] uppercase tracking-[0.4em] text-accent/90 mb-3 md:mb-4">{eyebrow}</p>
            )}
            <h1 className="font-headline text-4xl sm:text-5xl md:text-6xl lg:text-[5.25rem] text-cream leading-[1.08]">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-6 md:mt-8 text-cream/80 max-w-2xl mx-auto text-lg md:text-xl leading-relaxed">
                {subtitle}
              </p>
            )}
            {children && <div className="mt-8 md:mt-10">{children}</div>}
          </div>
        </>
      ) : (
        <div className="relative z-10 mx-auto max-w-content px-5 md:px-12 text-center">
          {eyebrow && (
            <p className="font-body text-[10px] uppercase tracking-[0.4em] text-accent/90 mb-3 md:mb-4">{eyebrow}</p>
          )}
          <h1 className="font-headline text-4xl sm:text-5xl md:text-6xl lg:text-[5.25rem] text-foreground leading-[1.08]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 md:mt-8 text-muted-foreground max-w-2xl mx-auto text-lg md:text-xl leading-relaxed">
              {subtitle}
            </p>
          )}
          {children && <div className="mt-8 md:mt-10">{children}</div>}
        </div>
      )}
    </section>
  );
};

export default PageHero;
